import React from "react";
import { compose } from "recompose";
import Grid from "@material-ui/core/Grid";
import "../../../utils/styles/Layout.css";

// The former "Sign in" promo block was gated on `sessionStorage.loggedIn === false` (a string never
// equals `false`), so it never rendered; it is gone with the legacy `loggedIn` flag.
const Component = () => (
  <Grid container>
    <Grid item sm={12} />
  </Grid>
);

export const enhance = compose();
export default enhance(Component);
